<p-menu #menuLigneRef [model]="menuLigne" [popup]="true"></p-menu>

<p-card *ngIf="!EstCharge()">
    <div class="flex justify-content-center">
        <p-progressSpinner></p-progressSpinner>
    </div>
</p-card>

<p-card *ngIf="EstCharge()">
    <div class="flex align-items-center gap-4 mb-4">
        <!-- Mini Map -->
        <div #headerMapContainer class="header-map w-6rem h-6rem border-round overflow-hidden flex-shrink-0"></div>

        <!-- Info Section -->
        <div class="flex-grow-1">
            <div class="flex align-items-center gap-3 mb-2">
                <h5 class="m-0">Rapport SST</h5>
                <span [class]="'statut ' + rapportSST.statut.nom.toLowerCase()">
                    {{rapportSST.statut.nom}}
                </span>
            </div>
            <div class="flex flex-wrap align-items-center gap-4 text-color-secondary">
                <div class="flex align-items-center gap-2">
                    <i class="pi pi-map-marker"></i>
                    <a [routerLink]="['/emplacement', rapportSST.emplacementId]"
                        class="text-primary no-underline hover:underline">
                        {{rapportSST.emplacement.code}} - {{rapportSST.emplacement.nom}}
                    </a>
                </div>
                <div class="flex align-items-center gap-2" pTooltip="Date du rapport">
                    <i class="pi pi-calendar"></i>
                    <span>{{rapportSST.date | date:'dd MMMM yyyy'}}</span>
                </div>
                <div class="flex align-items-center gap-2" pTooltip="Rapport préparé par">
                    <app-employe-avec-emplacement [employe]="rapportSST.employe"></app-employe-avec-emplacement>
                </div>
            </div>
        </div>
    </div>

    <app-menu-page-detail [model]="menu" [modeModification]="modeModification()" (onSave)="onSave($event)"
        (onCancel)="Annuler()" (onEdit)="Modifier()" [autoSaveInterval]="300000" [autoSaveDelay]="10000"
        (onAutoSave)="enregistrerModificationsAutoSave()"></app-menu-page-detail>
</p-card>

<p-card *ngIf="EstCharge()" styleClass="mt-3" id="prevision-meteo">
    <app-prevision-meteo [emplacementId]="rapportSST.emplacement?.emplacementId"></app-prevision-meteo>
</p-card>

<p-card *ngIf="EstCharge()" styleClass="mt-3">
    <p-tabView [scrollable]="true" [(activeIndex)]="tabIndex">
        <p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
            <div class="fluid formgrid grid">

                <!-- Numeric Inputs -->
                <div class="sihc-field col-12 md:col-6 lg:col-3 my-2">
                    <label class="font-semibold"><b>Nombre de travailleurs</b></label>
                    <span *ngIf="modeConsultation()">
                        <b>{{rapportSST.nbTravailleur | valeurVide}}</b> travailleurs
                        <br>
                        <small class="text-color-secondary">(Hamel et sous-traitants) sur le site</small>
                    </span>
                    <ng-container *ngIf="modeModification()">
                        <p-inputNumber [(ngModel)]="rapportSST.nbTravailleur" suffix=" travailleurs"></p-inputNumber>
                        <small class="text-color-secondary d-block ms-1">(Hamel et sous-traitants) sur le site</small>
                    </ng-container>
                </div>

                <div class="sihc-field col-12 md:col-6 lg:col-3 my-2">
                    <label class="font-semibold"><b>Nombre total de personnes</b></label>
                    <span *ngIf="modeConsultation()">
                        <b>{{rapportSST.nbTravailleurTotal | valeurVide}}</b> personnes
                        <br>
                        <small class="text-color-secondary">au chantier incluant le personnel de bureau et de
                            surveillance</small>
                    </span>
                    <ng-container *ngIf="modeModification()">
                        <p-inputNumber [(ngModel)]="rapportSST.nbTravailleurTotal" suffix=" personnes"></p-inputNumber>
                        <small class="text-color-secondary d-block ms-1">au chantier incluant le personnel de bureau et
                            de surveillance</small>
                    </ng-container>
                </div>

                <div class="sihc-field col-12 md:col-6 lg:col-3 my-2">
                    <label class="font-semibold"><b>Nombre d'incidents</b></label>
                    <span *ngIf="modeConsultation()">
                        <b>{{rapportSST.nbIncident | valeurVide}}</b> incidents
                        <br>
                        <small class="text-color-secondary">(incluant les passé-proche et bris matériel)</small>
                    </span>
                    <ng-container *ngIf="modeModification()">
                        <p-inputNumber [(ngModel)]="rapportSST.nbIncident" suffix=" incidents"></p-inputNumber>
                        <small class="text-color-secondary d-block ms-1">(incluant les passé-proche et bris
                            matériel)</small>
                    </ng-container>
                </div>

                <div class="sihc-field col-12 md:col-6 lg:col-3 my-2">
                    <label class="font-semibold"><b>Nombre de jours sans perte de temps</b></label>
                    <span *ngIf="modeConsultation()">
                        <b>{{rapportSST.nbJoursSansPerteDeTemps | valeurVide}}</b> jours
                    </span>
                    <ng-container *ngIf="modeModification()">
                        <p-inputGroup>
                            <p-inputNumber [(ngModel)]="rapportSST.nbJoursSansPerteDeTemps"
                                suffix=" jours"></p-inputNumber>
                            <button type="button" pButton icon="pi pi-eraser"
                                class="p-button-oulined p-button-secondary" pTooltip="Remettre à 0"
                                (click)="remettreAZeroNbJoursSansPerteDeTemps()"></button>
                        </p-inputGroup>
                    </ng-container>
                </div>

                <!-- Planification Textarea -->
                <div class="sihc-field col-12 my-2">
                    <label class="font-semibold">Planification quotidienne des travaux</label>
                    <sihc-quill-view *ngIf="modeConsultation()" [modules]="sdb.modules" [content]="rapportSST.planification"
                        [style]="{'max-height': '300px', 'overflow': 'hidden', 'overflow-y': 'scroll', 'border': '1px solid #e0e0e0', 'border-radius': '0.5rem' }"></sihc-quill-view>
                    <quill-editor *ngIf="modeModification()" #editor placeholder="Ecrivez votre message ici..."
                        [modules]="sdb.modules" [(ngModel)]="rapportSST.planification"></quill-editor>
                </div>

                <!-- Mécanismes SST appliqués -->
                <div class="sihc-field col-12 my-2">
                    <label class="font-semibold">Mécanismes SST appliqués aujourd'hui</label>
                    <small class="text-color-secondary block mb-2">(pour prévenir les risques - * ajouter les détails dans les commentaires)</small>
                    <div class="grid">
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indRdq" [binary]="true" [disabled]="modeConsultation()" inputId="indRdq"></p-checkbox>
                            <label for="indRdq" class="ml-2">RDQ (TB)</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indAccueilsChantier" [binary]="true" [disabled]="modeConsultation()" inputId="indAccueilsChantier"></p-checkbox>
                            <label for="indAccueilsChantier" class="ml-2">Accueils chantier</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indVisiteConjointeSst" [binary]="true" [disabled]="modeConsultation()" inputId="indVisiteConjointeSst" (onChange)="onMecanismeSstChange($event, 'Visite conjointe SST', 'indVisiteConjointeSst')"></p-checkbox>
                            <label for="indVisiteConjointeSst" class="ml-2">Visite conjointe SST*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indAst" [binary]="true" [disabled]="modeConsultation()" inputId="indAst"></p-checkbox>
                            <label for="indAst" class="ml-2">AST</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indAuditSstHc" [binary]="true" [disabled]="modeConsultation()" inputId="indAuditSstHc"></p-checkbox>
                            <label for="indAuditSstHc" class="ml-2">Audit SST HC</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indComiteChantier" [binary]="true" [disabled]="modeConsultation()" inputId="indComiteChantier"></p-checkbox>
                            <label for="indComiteChantier" class="ml-2">Comité de chantier</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indPauseSecurite" [binary]="true" [disabled]="modeConsultation()" inputId="indPauseSecurite"></p-checkbox>
                            <label for="indPauseSecurite" class="ml-2">Pause sécurité</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indFormation" [binary]="true" [disabled]="modeConsultation()" inputId="indFormation" (onChange)="onMecanismeSstChange($event, 'Formation', 'indFormation')"></p-checkbox>
                            <label for="indFormation" class="ml-2">Formation*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indVisiteCnesst" [binary]="true" [disabled]="modeConsultation()" inputId="indVisiteCnesst" (onChange)="onMecanismeSstChange($event, 'Visite CNESST', 'indVisiteCnesst')"></p-checkbox>
                            <label for="indVisiteCnesst" class="ml-2">Visite CNESST*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indInfoSst" [binary]="true" [disabled]="modeConsultation()" inputId="indInfoSst" (onChange)="onMecanismeSstChange($event, 'Info-SST', 'indInfoSst')"></p-checkbox>
                            <label for="indInfoSst" class="ml-2">Info-SST*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indInspMensuel" [binary]="true" [disabled]="modeConsultation()" inputId="indInspMensuel" (onChange)="onMecanismeSstChange($event, 'Insp. Mensuel', 'indInspMensuel')"></p-checkbox>
                            <label for="indInspMensuel" class="ml-2">Insp. Mensuel*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indDiffusionMethode" [binary]="true" [disabled]="modeConsultation()" inputId="indDiffusionMethode" (onChange)="onMecanismeSstChange($event, 'Diffusion de méthode', 'indDiffusionMethode')"></p-checkbox>
                            <label for="indDiffusionMethode" class="ml-2">Diffusion de méthode*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indPointArret" [binary]="true" [disabled]="modeConsultation()" inputId="indPointArret" (onChange)="onMecanismeSstChange($event, 'Point d\'arrêt', 'indPointArret')"></p-checkbox>
                            <label for="indPointArret" class="ml-2">Point d'arrêt*</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indReunionSstHc" [binary]="true" [disabled]="modeConsultation()" inputId="indReunionSstHc"></p-checkbox>
                            <label for="indReunionSstHc" class="ml-2">Réunion SST HC</label>
                        </div>
                        <div class="col-12 md:col-4 py-1">
                            <p-checkbox [(ngModel)]="rapportSST.indAutre" [binary]="true" [disabled]="modeConsultation()" inputId="indAutre" (onChange)="onMecanismeSstChange($event, 'Autre', 'indAutre')"></p-checkbox>
                            <label for="indAutre" class="ml-2">Autre*</label>
                        </div>
                    </div>
                </div>

                <div class="sihc-field col-12 md:col-3 mt-2 mb-4">
                    <label class="font-semibold">Temps passé au chantier</label>
                    <span *ngIf="modeConsultation()">{{formatMinutesForDisplay(rapportSST.minutesChantier) |
                        valeurVide}}</span>
                    <input *ngIf="modeModification()" pInputText type="text"
                        [value]="minutesToHoursMinutes(rapportSST.minutesChantier)"
                        (blur)="updateMinutesChantier($event)" placeholder="HH:MM" pattern="[0-9]{1,2}:[0-9]{2}"
                        class="w-full" />
                </div>
                <div class="sihc-field col-12 md:col-3 mt-2 mb-4">
                    <label class="font-semibold">Temps passé au bureau</label>
                    <span *ngIf="modeConsultation()">{{formatMinutesForDisplay(rapportSST.minutesBureau) |
                        valeurVide}}</span>
                    <input *ngIf="modeModification()" pInputText type="text"
                        [value]="minutesToHoursMinutes(rapportSST.minutesBureau)" (blur)="updateMinutesBureau($event)"
                        placeholder="HH:MM" pattern="[0-9]{1,2}:[0-9]{2}" class="w-full" />
                </div>

                <!-- Table of LigneRapportSst -->
                <div class="field col-12">
                    <p *ngIf="nbLignesSupprimees() > 0" class="text-red-500">Nombre de lignes supprimées:
                        {{nbLignesSupprimees()}}</p>
                    <p-table [value]="lignesFiltrees()" [scrollable]="true" responsiveLayout="stack"
                        [contextMenu]="menuLigneRef" [(contextMenuSelection)]="selectedLigne">
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between align-items-center">
                                <div class="flex-grow-1 text-center">
                                    <h5 class="m-0 pt-3">Lignes du rapport</h5>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th rowspan="2">#</th>
                                <th rowspan="2">Entreprise</th>
                                <th rowspan="2">Lieu</th>
                                <th rowspan="2">Description</th>
                                <th colspan="3" style="color: #F00; text-align: center;">
                                    <div class="flex align-items-center justify-content-center gap-2">
                                        <span>Analyse des risques</span>
                                        <p-button icon="pi pi-question-circle" (onClick)="showRiskMatrix()"
                                            styleClass="p-button-text p-button-rounded"
                                            pTooltip="Matrice d'évaluation des risques" pTooltipPosition="left">
                                        </p-button>
                                    </div>
                                </th>
                                <th rowspan="2">Risque/Danger</th>
                                <th rowspan="2">Mesures correctives</th>
                                <th rowspan="2">Corrigé</th>
                                <th rowspan="2"></th>
                            </tr>
                            <tr>
                                <th>Probabilité</th>
                                <th>Gravité</th>
                                <th>Total</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-ligne let-i="rowIndex">
                            <tr [ngClass]="{
                                'ligne-bon-coup': getLineState(ligne) === 'boncoup',
                                'ligne-observation': getLineState(ligne) === 'observation',
                                'ligne-non-conformite': getLineState(ligne) === 'nonconformite'
                            }"
                                [pContextMenuRow]="ligne" [pContextMenuRowDisabled]="!modeModification()">
                                <td>
                                    <div class="flex align-items-center gap-2">
                                        <span class="font-semibold">{{i + 1}}</span>
                                        
                                        <!-- State Badge -->
                                        <i *ngIf="getLineState(ligne) === 'boncoup'" 
                                            class="pi pi-thumbs-up state-badge state-badge-boncoup"
                                            pTooltip="Bon coup"
                                            tooltipPosition="right"></i>
                                        <i *ngIf="getLineState(ligne) === 'observation'" 
                                            class="pi pi-eye state-badge state-badge-observation"
                                            pTooltip="Observation"
                                            tooltipPosition="right"></i>
                                        <i *ngIf="getLineState(ligne) === 'nonconformite'" 
                                            class="pi pi-exclamation-triangle state-badge state-badge-nonconformite"
                                            pTooltip="Non-conformité"
                                            tooltipPosition="right"></i>
                                        
                                        <!-- Non-conformité Details -->
                                        <span *ngIf="getLineState(ligne) === 'nonconformite'" class="text-sm ml-2">
                                            depuis {{getDateNonConformite(ligne)}}
                                        </span>
                                    </div>
                                </td>
                                <td pEditableColumn="entreprise">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Entreprise</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-autoComplete *ngIf="modeModification()"
                                                    [suggestions]="suggestionCompagnie"
                                                    (completeMethod)="rechercherCompagnie($event)"
                                                    [(ngModel)]="ligne.entreprise" appendTo="body"
                                                    (onKeyUp)="ligne.dirty.set(true)">
                                                </p-autoComplete>
                                                <div *ngIf="modeConsultation()">
                                                    {{ ligne.entreprise | valeurVide }}
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ ligne.entreprise | valeurVide }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td pEditableColumn="lieu">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Lieu</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input *ngIf="modeModification()" pInputText type="text"
                                                    [(ngModel)]="ligne.lieu" (onChange)="ligne.dirty.set(true)" />
                                                <div *ngIf="modeConsultation()">
                                                    {{ ligne.lieu | valeurVide }}
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ ligne.lieu | valeurVide }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td pEditableColumn="description">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Description</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <textarea *ngIf="modeModification()" pInputTextarea type="text"
                                                    [(ngModel)]="ligne.description"
                                                    (onChange)="ligne.dirty.set(true)"></textarea>
                                                <div *ngIf="modeConsultation()">
                                                    {{ ligne.description | valeurVide }} {{ligne.total()}}
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ ligne.description | valeurVide }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <!-- State Selection / Display -->
                                <td *ngIf="getLineState(ligne) === 'boncoup'" colspan="3" class="state-toggle-cell">
                                    <div class="flex flex-column justify-content-center align-items-center gap-3 w-full">
                                        <!-- Edit Mode: Toggle Buttons -->
                                        <p-selectButton *ngIf="modeModification()" 
                                            [options]="[
                                                {label: 'Bon coup', value: 'boncoup', icon: 'pi pi-thumbs-up'},
                                                {label: 'Observation', value: 'observation', icon: 'pi pi-eye'},
                                                {label: 'Non-conformité', value: 'nonconformite', icon: 'pi pi-exclamation-triangle'}
                                            ]"
                                            [ngModel]="getLineState(ligne)"
                                            (onChange)="setLineState(ligne, $event.value)"
                                            [unselectable]="false"
                                            optionLabel="label"
                                            optionValue="value"
                                            styleClass="state-toggle w-full">
                                            <ng-template let-item>
                                                <i [class]="item.icon + ' mr-2'"></i>
                                                <span class="hidden md:inline">{{item.label}}</span>
                                            </ng-template>
                                        </p-selectButton>
                                        
                                        <!-- View Mode: Badge -->
                                        <p-tag *ngIf="modeConsultation()" 
                                            severity="success" 
                                            value="Bon coup"
                                            icon="pi pi-thumbs-up"
                                            styleClass="text-lg">
                                        </p-tag>
                                    </div>
                                </td>

                                <!-- Observation State (no risk analysis) -->
                                <td *ngIf="getLineState(ligne) === 'observation'" colspan="3" class="state-toggle-cell">
                                    <div class="flex flex-column justify-content-center align-items-center gap-3 w-full">
                                        <!-- Toggle Buttons -->
                                        <p-selectButton *ngIf="modeModification()" 
                                            [options]="[
                                                {label: 'Bon coup', value: 'boncoup', icon: 'pi pi-thumbs-up'},
                                                {label: 'Observation', value: 'observation', icon: 'pi pi-eye'},
                                                {label: 'Non-conformité', value: 'nonconformite', icon: 'pi pi-exclamation-triangle'}
                                            ]"
                                            [ngModel]="getLineState(ligne)"
                                            (onChange)="setLineState(ligne, $event.value)"
                                            [unselectable]="false"
                                            optionLabel="label"
                                            optionValue="value"
                                            styleClass="state-toggle w-full">
                                            <ng-template let-item>
                                                <i [class]="item.icon + ' mr-2'"></i>
                                                <span class="hidden md:inline">{{item.label}}</span>
                                            </ng-template>
                                        </p-selectButton>

                                        <!-- View Mode: Badge -->
                                        <p-tag *ngIf="modeConsultation()" 
                                            severity="warning" 
                                            value="Observation"
                                            icon="pi pi-eye"
                                            styleClass="text-lg">
                                        </p-tag>
                                    </div>
                                </td>

                                <!-- Non-conformité State (with risk analysis) -->
                                <td *ngIf="getLineState(ligne) === 'nonconformite'"
                                    colspan="3" class="state-toggle-cell">
                                    <div class="flex flex-column justify-content-center align-items-center gap-3 w-full">
                                        <!-- Toggle Buttons -->
                                        <p-selectButton *ngIf="modeModification()" 
                                            [options]="[
                                                {label: 'Bon coup', value: 'boncoup', icon: 'pi pi-thumbs-up'},
                                                {label: 'Observation', value: 'observation', icon: 'pi pi-eye'},
                                                {label: 'Non-conformité', value: 'nonconformite', icon: 'pi pi-exclamation-triangle'}
                                            ]"
                                            [ngModel]="getLineState(ligne)"
                                            (onChange)="setLineState(ligne, $event.value)"
                                            [unselectable]="false"
                                            optionLabel="label"
                                            optionValue="value"
                                            styleClass="state-toggle w-full mb-2">
                                            <ng-template let-item>
                                                <i [class]="item.icon + ' mr-2'"></i>
                                                <span class="hidden md:inline">{{item.label}}</span>
                                            </ng-template>
                                        </p-selectButton>

                                        <!-- View Mode: Badge -->
                                        <p-tag *ngIf="modeConsultation()" 
                                            severity="danger" 
                                            value="Non-conformité"
                                            icon="pi pi-exclamation-triangle"
                                            styleClass="text-lg mb-2">
                                        </p-tag>

                                        <!-- Risk Analysis Grid (only for non-conformité) -->
                                        <div class="grid w-full">
                                            <div class="col-12 md:col-4">
                                                <label class="text-sm font-semibold block mb-2">Probabilité</label>
                                                <p-inputNumber *ngIf="modeModification()" 
                                                    [(ngModel)]="ligne.probabilite" 
                                                    [min]="0" [max]="5"
                                                    showButtons 
                                                    buttonLayout="horizontal" 
                                                    [step]="1"
                                                    (onInput)="ligne.total.set(Math.min(Math.max(ligne.probabilite, 0), 5) * Math.min(Math.max(ligne.gravite, 0), 5))"
                                                    styleClass="w-full">
                                                </p-inputNumber>
                                                <span *ngIf="modeConsultation()">{{ligne.probabilite | valeurVide}}</span>
                                            </div>
                                            <div class="col-12 md:col-4">
                                                <label class="text-sm font-semibold block mb-2">Gravité</label>
                                                <p-inputNumber *ngIf="modeModification()" 
                                                    [(ngModel)]="ligne.gravite" 
                                                    [min]="0" [max]="5"
                                                    showButtons 
                                                    buttonLayout="horizontal" 
                                                    [step]="1"
                                                    (onInput)="ligne.total.set(Math.min(Math.max(ligne.probabilite, 0), 5) * Math.min(Math.max(ligne.gravite, 0), 5))"
                                                    styleClass="w-full">
                                                </p-inputNumber>
                                                <span *ngIf="modeConsultation()">{{ligne.gravite | valeurVide}}</span>
                                            </div>
                                            <div class="col-12 md:col-4">
                                                <label class="text-sm font-semibold block mb-2">Total</label>
                                                <div class="flex align-items-center gap-2">
                                                    <span class="text-xl font-bold">{{ligne.total()}}</span>
                                                    <p-tag [severity]="ligne.severite()" [value]="ligne.severiteLabel()"></p-tag>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <!-- Legacy Risk Analysis Columns (kept for backwards compatibility, hidden when using new state system) -->
                                <td *ngIf="false"
                                    pEditableColumn="probabilite">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Probabilité</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <div #probabiliteInput>
                                                    <p-inputNumber [(ngModel)]="ligne.probabilite" [min]="0" [max]="5"
                                                        showButtons [readonly]="modeConsultation()"
                                                        buttonLayout="horizontal" [step]="1"
                                                        (onInput)="ligne.total.set(Math.min(Math.max(ligne.probabilite, 0), 5) * Math.min(Math.max(ligne.gravite, 0), 5))"></p-inputNumber>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ligne.probabilite | valeurVide}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td *ngIf="false"
                                    pEditableColumn="gravite">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Gravité</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <div>
                                                    <p-inputNumber [(ngModel)]="ligne.gravite" [min]="0" [max]="5"
                                                        showButtons [readonly]="modeConsultation()"
                                                        buttonLayout="horizontal" [step]="1"
                                                        (onInput)="ligne.total.set(Math.min(Math.max(ligne.probabilite, 0), 5) * Math.min(Math.max(ligne.gravite, 0), 5))"></p-inputNumber>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ligne.gravite | valeurVide}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td *ngIf="false">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Total</h6>
                                        <div class="flex align-items-center gap-2">
                                            <span style="font-size: 1.2rem; font-weight: bold;">{{ligne.total()}}</span>
                                            <p-tag [severity]="ligne.severite()"
                                                [value]="ligne.severiteLabel()"></p-tag>
                                        </div>
                                    </div>
                                </td>
                                <td pEditableColumn="risqueDanger">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Risque/Danger</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <textarea *ngIf="modeModification()" pInputTextarea type="text"
                                                    [(ngModel)]="ligne.risqueDanger"
                                                    (onChange)="ligne.dirty.set(true)"></textarea>
                                                <div *ngIf="modeConsultation()">
                                                    {{ ligne.risqueDanger | valeurVide }}
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ ligne.risqueDanger | valeurVide }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td pEditableColumn="mesuresCorrectives">
                                    <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Mesures correctives</h6>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <textarea *ngIf="modeModification()" pInputTextarea type="text"
                                                    [(ngModel)]="ligne.mesuresCorrectives"
                                                    (onChange)="ligne.dirty.set(true)"></textarea>
                                                <div *ngIf="modeConsultation()">
                                                    {{ ligne.mesuresCorrectives | valeurVide }}
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ ligne.mesuresCorrectives | valeurVide }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td>
                                    <div *ngIf="ligne.total() > environment.rapportSst.niveauNonConformite"
                                        class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                                        <h6 *ngIf="appMain.isMobile" class="p-column-title">Corrigé</h6>
                                        <div *ngIf="ligne.indCorrige" class="text-green-500">Le
                                            {{ligne.dateCorrection?.toLocaleDateString('fr-CA')}}</div>
                                        <div *ngIf="ligne.indCorrige == false" class="text-red-500">Non</div>
                                    </div>
                                </td>
                                <td>
                                    <p-button *ngIf="modeModification()" icon="pi pi-bars" outlined size="small"
                                        [disabled]="!ligne.dirty()"
                                        (onClick)="afficherMenuLigne($event, ligne)"></p-button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="12" class="text-center">Aucune ligne du rapport</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <!-- Comments Section with Rich Text Editor -->
                <div class="sihc-field col-12">
                    <label class="font-semibold">Commentaires</label>
                    <sihc-quill-view *ngIf="modeConsultation()" [modules]="sdb.modules" [content]="rapportSST.commentaire"
                        [style]="{'max-height': '300px', 'overflow': 'hidden', 'overflow-y': 'scroll', 'border': '1px solid #e0e0e0', 'border-radius': '0.5rem' }"></sihc-quill-view>
                    <quill-editor *ngIf="modeModification()" placeholder="Entrez vos commentaires..."
                        [modules]="sdb.modules" [(ngModel)]="rapportSST.commentaire"></quill-editor>
                    
                    <!-- Mechanism SST detail inputs -->
                    <div *ngIf="modeModification() && mecanismeSstInputs().length > 0" class="mt-3 p-3 surface-ground border-round">
                        <small class="text-color-secondary block mb-2">Détails des mécanismes SST sélectionnés:</small>
                        <div *ngFor="let input of mecanismeSstInputs(); trackBy: trackByPropertyName" class="flex align-items-center gap-2 mb-2">
                            <label class="font-medium text-sm white-space-nowrap" style="min-width: 150px;">- {{input.name}}:</label>
                            <input pInputText type="text" [(ngModel)]="input.description" 
                                class="flex-grow-1" placeholder="Ajouter les détails...">
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Documents" leftIcon="pi pi-file-pdf">
            <ng-template pTemplate="content">
                <p-message styleClass="w-full mb-2" severity="info"
                    [text]="'Ne pas oublier d\'identifier les points SST (position ou négatif) dans la description de vos photos'"></p-message>
                <app-document [typeLienDocument]="ETypeLienDocument.RapportSST" [idLien]="rapportSST.rapportSstId"
                    [numero]="rapportSST.emplacement.code + ' - ' + rapportSST.date" [showFolders]="false"
                    [mandatoryDescription]="true"></app-document>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</p-card>

<p-dialog header="Matrice d'évaluation des risques" [(visible)]="showRiskMatrixDialog" [modal]="true"
    [style]="{width: '90vw', maxWidth: '1200px'}" [draggable]="false" [resizable]="false" [closeOnEscape]="true"
    [dismissableMask]="true">
    <app-matrice-risque></app-matrice-risque>
</p-dialog>